/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
import {
    Breadcrumb, Button, Panel, Select, SelectOption, Tab, Tabs,
} from 'appkit-react';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import ClassifyResult from './ClassifyResult';
import AduitLogs from '../containers/AduitLogs';
import Remediation from './Remediation';
import Comments from '../containers/FRY7QComments';
import FRY7QResultsAccordian from './FRY7QResultsAccordian';
import '../styles/fyresults.scss';

const FRY7QResults = ({
    auditLog, breadcrumbItems, failedTestsData, refetch, onNavigate, period, remediation, criteria, failedTestResults,
}) => {
    const history = useHistory();
    const [showClassifyResult, setShowClassifyResult] = useState(false);

    return (
        <>

            <div className="true-comply-fry7q-results_layout">
                <div className="true-comply-fry7q-results_column-2">
                    <Breadcrumb items={breadcrumbItems} />
                    <Row>
                        <Col md={4}>
                            <div className="a-h2 title-label">
                                <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.goBack()} role="presentation" />
                                {`Rule #${criteria.ruleId} Results`}
                            </div>
                        </Col>
                        <Col className="classyfy_btn_container">
                            <Row>
                                <Col style={{ textAlign: 'right' }}>
                                    <span>
                                        <span className="a-h6" style={{ marginRight: '0.5rem' }}> Run Period </span>
                                        <Select disabled value={period}>
                                            <SelectOption key={1} value={period}>{period}</SelectOption>
                                        </Select>
                                        <Button size="lg" style={{ marginLeft: '1rem' }} onClick={() => setShowClassifyResult(true)}>
                                            CLASSIFY RESULTS
                                        </Button>
                                        {showClassifyResult
                                            && (
                                                <ClassifyResult
                                                    setShowClassifyResult={setShowClassifyResult}
                                                    refetch={auditLog.refetch}
                                                    refetchTestData={refetch}
                                                />
                                            )}
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    {/* Import accordian results and Diagonstic criteria component */}
                    <FRY7QResultsAccordian
                        failedTestResults={failedTestResults}
                        criteria={criteria}
                    />

                    <Panel style={{ marginTop: '1rem', marginBottom: '2rem' }}>
                        <Tabs defaultValue="1" className="a-tab-item-padding-10" size="md">
                            <Tab value="1" label="REMEDIATION">
                                {remediation && remediation.length ? <Remediation failedTestsData={failedTestsData} refetch={auditLog.refetch} refetchTestData={refetch} /> : (
                                    <div className="a-h4">
                                        Remediation is not allowed for passed test cases
                                    </div>
                                )}
                            </Tab>
                            <Tab value="2" label="COMMENTS">
                                <Comments refetch={auditLog.refetch} />
                            </Tab>
                            <Tab value="3" label="AUDIT LOG">
                                <AduitLogs data={auditLog.data && auditLog.data.getAuditLogsForFRY7Q} />
                            </Tab>
                        </Tabs>
                    </Panel>
                </div>
            </div>
        </>
    );
};

export default FRY7QResults;
